/* global $ */
// all the code could have been in printSettingsView.js
// BUT it concern only lasercut at the time
// and even if it is really link to the selector in printSettingsView.js It is better to separate the code
(function (scope) {
  "use strict";

  var PrintPreviewMaterialView = (scope.PrintPreviewMaterialView = function (
    controller
  ) {
    this.controller = controller;

    //the code is link with the selector in setting process
    this.$el = $(".setting-process");

    this.$el.on(
      "mouseover",
      "[data-material-preview]",
      this.showPreview.bind(this)
    );
    this.$el.on(
      "mouseout",
      "[data-material-preview]",
      this.hidePreview.bind(this)
    );
  });

  /**
   *
   * @public
   */
  PrintPreviewMaterialView.prototype.showPreview = function (event) {
    var $target = $(event.currentTarget);

    //for the moment we need to show the preview material only for the color in lasercut (material-results == color on the selector)
    if ($target.closest("#select2-select-material-results").length == 0) {
      return;
    }

    //get the selector where we will add the preview
    var $materialSelector = $("#select-material", this.$el).next();

    var previewUrl =
      "/static/dev/images/material_previews/new_lasercut/" +
      $target.data("material-preview");

    //hide all previous preview
    this.hidePreview();

    //create the preview
    var $preview = $("<div>").addClass("preview-material-container");

    //add the img in the preview
    $preview.append("<img src='" + previewUrl + ".jpg'>");

    $preview.hide();

    //add the preview to the material selector
    $materialSelector.prepend($preview);

    $preview.fadeIn(300);
  };

  /**
   *
   * @public
   */
  PrintPreviewMaterialView.prototype.hidePreview = function (event) {
    $(".preview-material-container", this.$el).remove();
  };
})((window.sculpteo = window.sculpteo || {}));
